import { BadgeProps } from '@/decodo/components/atoms/badge';

export const mutualBadgeProps: BadgeProps = {
  size: 'l',
  classNames: {
    root: 'cursor-pointer border',
  },
};
export const selectedTagProps: BadgeProps = {
  ...mutualBadgeProps,
  colors: 'tertiary-500',
  variant: 'filled',
};
export const unSelectedTagProps: BadgeProps = {
  ...mutualBadgeProps,
  colors: 'gray-300',
  variant: 'outlined',
};
